import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import axios from "axios";
import { Button } from 'reactstrap';
import { Configurations } from '../../Utils/Configurations';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ErrorModal from '../ErrorModal/ErrorModal';

const HeaderEpub = (props) => {

    const { pageTitle, nextPage, status, etapa, salvarAlteracao, bookId, history, loadingSalvar, chamadaLivro, disableSalvar } = props;

    const id = (bookId && bookId !== 'novo') ? bookId : (nextPage || null);

    const [loading, setLoading] = useState(false);
    const [successModal, setSuccessModal] = useState(false);
    const [errorModal, setErrorModal] = useState(false);
    const [message, setMessage] = useState('');
    const [aproveModal, setAproveModal] = useState(false);
    const [promoteModal, setPromoteModal] = useState(false);
    const [successAproveModal, setSuccessAproveModal] = useState(false);

    const go = (path) => {
        if (!path) return;
        history.push(path);
    };

    const closeSuccessAndRedirectToBooks = () => {
        setSuccessModal(false);
        go('/cile/conteudo/livros?pagina=1&limite=10');
    };

    const closeSuccessAndRedirectToEpubList = () => {
        setSuccessModal(false);
        go('/cile/conteudo/epub/lista?pagina=1');
    };

    const promoteToProduction = async () => {
        const config = new Configurations();
        setLoading(true);

        axios.post(config.apiBasePath + `/conteudo-cile/epub/producao/processar/${bookId}`)
            .then(response => {
                setLoading(false);
                toggleSuccessModal()
            })
            .catch(error => {
                console.error('erro: ', error)
                setLoading(false);
                setMessage('Ocorreu um erro ao promover o livro para produção. Tente novamente mais tarde.');
                toggleErrorModal();
            });

    }

    const aproveBook = async () => {
        const config = new Configurations();
        setLoading(true);

        axios.post(config.apiBasePath + `/conteudo-cile/epub/homologacao/aprovar/${bookId}`)
            .then(response => {
                console.log("🚀 ~ aproveBook ~ response:", response)
                setLoading(false);
                setSuccessAproveModal(true);
                chamadaLivro()
            })
            .catch(error => {
                console.error('erro: ', error)
                setLoading(false);
                setMessage('Ocorreu um erro ao aprovar homologação do livro.');
                toggleErrorModal();
            });

    }

    const toggleSuccessModal = () => {
        setSuccessModal(!successModal);
    }

    const toggleErrorModal = () => {
        setErrorModal(!errorModal);
    }

    const getStatusBadge = (value) => {
        switch (value) {
            case 0:
                return { className: 'secondary', text: 'Não iniciado' };
            case 1:
                return { className: 'warning badge-opacity text-dark', text: 'Em homologação' }; //aprovar hml e vira homologado
            case 2:
                return { className: 'primary badge-opacity', text: 'Homologado' }; // aprova de hml - botão vira copiar para produção
            case 3:
                return { className: 'success badge-opacity', text: 'Em produção' };
            default:
                return { className: 'secondary badge-opacity', text: 'Não iniciado' };
        }
    };

    return (
        <>
            <div className="col-12 py-2">
                <div className="row no-gutters align-items-center">
                    <div className={`col-12 ${etapa === 2 ? 'col-lg-4' : 'col-lg-3'} text-center text-lg-left`}>
                        <h2 className="title-1 d-none d-lg-block">{pageTitle}</h2>
                    </div>

                    <div className="col-12 col-lg-4 text-center d-flex align-items-center justify-content-center">
                        {etapa === 1 && (
                            <>
                                {bookId !== 'novo' && id && (
                                    <>
                                        <button className="btn btn-outline-primary mr-3" onClick={() => go(`/cile/conteudo/epub/detalhes/arquivos/${id}`)}>Upload Arquivos</button>
                                        <button className="btn btn-outline-primary" onClick={() => go(`/cile/conteudo/epub/detalhes/geracao/${id}`)}>Gerar Livro</button>
                                    </>
                                )}
                            </>
                        )}

                        {etapa === 2 && (
                            <>
                                <button className="btn btn-outline-primary mr-3" onClick={() => go(`/cile/conteudo/epub/detalhes/${id || nextPage}`)}>Editar Livro</button>
                                <button className="btn btn-outline-primary" onClick={() => go(`/cile/conteudo/epub/detalhes/geracao/${id || nextPage}`)} disabled={!id}>Gerar Livro</button>
                            </>
                        )}

                        {etapa === 3 && status !== 3 && (
                            <>
                                <button className="btn btn-outline-primary mr-3" onClick={() => go(`/cile/conteudo/epub/detalhes/${id || nextPage}`)}>Editar Livro</button>
                                <button className="btn btn-outline-primary" onClick={() => go(`/cile/conteudo/epub/detalhes/arquivos/${id || nextPage}`)}>Upload de arquivos</button>
                            </>
                        )}
                    </div>

                    <div className="col-12 col-lg-2 text-center d-flex align-items-center justify-content-center">
                        {bookId === 'novo' ? null : (
                            <p key={1} className="m-0">Status: <span className={`badge badge-${getStatusBadge(status).className}`}>{getStatusBadge(status).text}</span>
                            </p>
                        )}
                    </div>

                    {etapa !== 2 && (
                        <div className="col-12 col-lg-2 text-center d-flex align-items-center justify-content-center">
                            {etapa === 3 && status === 2 && (
                                <button className="btn btn-outline-success" onClick={() => setPromoteModal(!promoteModal)} disabled={loading}>
                                    {loading ? 'Processando...' : 'Copiar para produção'}
                                </button>
                            )}
                            {etapa === 3 && status === 1 && (
                                <button className="btn btn-outline-success" onClick={() => setAproveModal(!aproveModal)} disabled={loading}>
                                    {loading ? 'Processando...' : 'Aprovar'}
                                </button>
                            )}
                            {etapa === 1 && (
                                <button className="btn btn-outline-success" onClick={() => salvarAlteracao()} disabled={loadingSalvar || disableSalvar}>
                                    {loadingSalvar ? 'Salvando...' : 'Salvar'}
                                </button>
                            )}
                        </div>
                    )}

                    <div className="col-12 col-lg-1 text-center text-lg-right">
                        <div className="row no-gutters">
                            <div className="col py-2 py-lg-0">
                                <button onClick={() => window.history.go(-1)} className="btn btn-outline-secondary">voltar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ErrorModal
                isOpen={errorModal}
                message={message}
                closeErrorModal={toggleErrorModal}
            />

            <Modal isOpen={successAproveModal} toggle={() => setSuccessAproveModal(!successAproveModal)}>
                <ModalHeader toggle={() => setSuccessAproveModal(!successAproveModal)}>
                    Sucesso
                </ModalHeader>
                <ModalBody>
                    <p>Livro aprovado com sucesso!</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => setSuccessAproveModal(!successAproveModal)}>OK</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={successModal} toggle={closeSuccessAndRedirectToEpubList}>
                <ModalHeader toggle={closeSuccessAndRedirectToEpubList}>
                    Sucesso
                </ModalHeader>
                <ModalBody>
                    <p>Livro promovido para produção com sucesso!</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={closeSuccessAndRedirectToBooks}>OK</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={aproveModal} toggle={() => setAproveModal(!aproveModal)}>
                <ModalHeader toggle={() => setAproveModal(!aproveModal)}>
                    Aprovar Homologação
                </ModalHeader>
                <ModalBody>
                    <p>Tem certeza que deseja aprovar a homologação deste livro?</p>
                </ModalBody>
                <ModalFooter>
                    {loading ? (
                        <div className="spinner-border spinner-border-sm text-success" role="status" />
                    ) : (
                        <Button color="success" onClick={() => aproveBook()}>Sim</Button>
                    )}
                    <Button color="danger" onClick={() => setAproveModal(!aproveModal)}>Não</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={promoteModal} toggle={() => setPromoteModal(!promoteModal)}>
                <ModalHeader toggle={() => setPromoteModal(!promoteModal)}>
                    Copiar para produção
                </ModalHeader>
                <ModalBody>
                    <p>Tem certeza que deseja copiar este livro para produção?</p>
                </ModalBody>
                <ModalFooter>
                    {loading ? (
                        <div className="spinner-border spinner-border-sm text-success" role="status" />
                    ) : (
                        <Button color="success" onClick={() => promoteToProduction()}>Sim</Button>
                    )}
                    <Button color="danger" onClick={() => setPromoteModal(!promoteModal)}>Não</Button>
                </ModalFooter>
            </Modal>
        </>
    );
}
export default withRouter(HeaderEpub);